module.exports = __webpack_public_path__ + "img/ic-professional.a80076a2.svg";